export default __webpack_public_path__ + "static/media/b-corp-regener.5790a4de.png";